import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.object.from-entries.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var a = /*#__PURE__*/function (_Error) {
  _inherits(a, _Error);
  var _super = _createSuper(a);
  function a(c) {
    var _this;
    _classCallCheck(this, a);
    _this = _super.call(this, c), Object.setPrototypeOf(_assertThisInitialized(_this), a.prototype);
    return _this;
  }
  return _createClass(a);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var A = /[\s\t\n\r]/,
  O = /[{}[\]=,:]/,
  v = /["']/,
  x = /[a-zA-Z_$-]/,
  f = /[0-9]/,
  N = /[a-zA-Z_$-]|[0-9]/,
  m = function m(e) {
    var c = 0,
      r = 0;
    var o = [],
      t = function t() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return e[r + n];
      },
      u = function u() {
        return e[r++];
      },
      l = function l() {
        return r >= e.length;
      };
    function d(n) {
      for (; t() !== n && !l();) {
        u();
      }
      if (l()) throw new a("Unterminated string");
      u(), o.push(e.substring(c, r));
    }
    function h() {
      for (; f.test(t());) {
        u();
      }
      if (t() === "-" && f.test(t(1))) {
        for (u(); f.test(t());) {
          u();
        }
        o.push(e.substring(c, r));
        return;
      }
      if (t() === "." && f.test(t(1))) for (u(); f.test(t());) {
        u();
      }
      o.push(parseFloat(e.substring(c, r)));
    }
    function g() {
      for (; N.test(t()) && !l();) {
        u();
      }
      o.push(e.substring(c, r));
    }
    function b() {
      for (; !l();) {
        c = r;
        var n = u();
        if (!A.test(n)) if (O.test(n)) o.push(n);else if (v.test(n)) d(n);else if (f.test(n)) h();else if (x.test(n)) g();else throw new a("Unexpected character ".concat(n));
      }
      return o;
    }
    return b();
  },
  y = {
    true: !0,
    false: !1,
    NaN: NaN,
    null: null,
    undefined: void 0
  },
  S = "highlight",
  E = function E(e) {
    return typeof e == "string" && /^(['"]).*\1$/.test(e);
  },
  j = function j(e) {
    var c = 0;
    var r = new Map(),
      o = function o() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return e[c + s];
      },
      t = function t() {
        return e[c++];
      },
      u = function u() {
        return c >= e.length;
      };
    function l(s, i, w) {
      var p = [];
      if (t(), o() !== i) for (p.push(w()); o() === ",";) {
        if (t(), o() === i) throw new a("Trailing comma");
        p.push(w());
      }
      if (t() !== i) throw new a("Unterminated ".concat(s));
      return p;
    }
    function d() {
      return l("array", "]", g);
    }
    function h() {
      return Object.fromEntries(l("object", "}", function () {
        var _n = n(":"),
          _n2 = _slicedToArray(_n, 2),
          i = _n2[0],
          w = _n2[1];
        return [E(i) ? i.slice(1, -1) : String(i), w];
      }));
    }
    function g() {
      var s = o();
      return s === "{" ? h() : s === "[" ? d() : E(s) ? t().slice(1, -1) : s in y ? y[t()] : t();
    }
    function b() {
      var s = r.has(S) ? r.get(S) : {};
      return [S, _objectSpread(_objectSpread({}, s), h())];
    }
    function n() {
      var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "=";
      var i = t();
      return o() === s ? (t(), [i, g()]) : [i, !0];
    }
    function k() {
      for (; !u();) {
        var _ref = o() === "{" ? b() : n(),
          _ref2 = _slicedToArray(_ref, 2),
          s = _ref2[0],
          i = _ref2[1];
        r.set(String(s).toLowerCase(), i);
      }
      return r;
    }
    return Object.fromEntries(k());
  },
  U = function U(e) {
    return j(m(e));
  };
export { a as FenceparserError, U as default, m as lex, j as parse };